import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 21,
  steps: [
    addColumns({
      table: 'chats',
      columns: [
        { name: 'key', type: 'string', isIndexed: true },
        { name: 'is_chat_key', type: 'boolean' }
      ]
    })
  ]
}
